export default __webpack_public_path__ + "img/62abac60fee20c7a3fa288ecd613c76c.svg";